/** @jsx jsx */
import { jsx } from 'theme-ui'
import { string } from 'prop-types'

const ProgressLine = ({ stepStatus, ...props }) => {
  const stepColor = stepStatus !== 'completed' ? 'silver' : 'forest80'

  return (
    <svg
      width={123}
      height={4}
      viewBox="0 0 123 4"
      sx={{ fill: stepColor }}
      {...props}
    >
      <rect width="123" height="4" rx="2" />
    </svg>
  )
}

ProgressLine.propTypes = {
  stepStatus: string,
}

export default ProgressLine
